import Alert from '@amzn/meridian/alert';
import Box from '@amzn/meridian/box';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import { FieldArray, FormikProps, useFormikContext } from 'formik';
import React, { useState } from 'react';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';

import {
  CoachingDetailsInput,
  CoachingFormData,
  ContactInput,
  defaultContactReviewValues,
} from '../../../api/CoachingForm/schema';
import { getCSCEndpoint } from '../../../config/Config';
import DataState from '../../../Types/DataState';
import { renderUrl, urls } from '../../../config/Url';
import { getDateRangeFromWeek } from '../../../Util';
import { getAllMetrics, getTopicByMetric } from '../CoachingDetails/Data';
import ConditionalTooltip from '../FieldComponents/ConditionalTooltip';
import ErrorMessage from '../FieldComponents/ErrorMessage';
import { getLabelFromValue } from '../FieldComponents/Helpers';
import FieldArrayDisplay, {
  DisplayObject,
} from '../LayoutComponents/FieldArrayDisplay';
import {
  ContactFromGetter,
  getAllSecurityOptions,
  getAllVerticals,
} from './Data';

export const convertReviewToDisplay = (
  review: ContactInput,
  intl: IntlShape
): DisplayObject[] => {
  const { startDate: contactStartDate, endDate: contactEndDate } =
    getDateRangeFromWeek(
      `${review.contactTime?.calYear}-${review.contactTime?.calWeek}`
    );

  const contactDisplay = {
    label: intl.formatMessage({
      id: 'cs_perfportal_contact_review_label_readonly_contact_id',
      defaultMessage: 'Contact ID:',
    }),
    value:
      review.marketplaceDomainName !== null &&
      review.marketplaceDomainName !== undefined
        ? {
            text: review.cscContactID,
            href: renderUrl(
              // eslint-disable-next-line max-len
              `/gp/stores/${review.marketplaceDomainName}/gp/communications/issue-manager?initialCommId=${review.cscContactID}`,
              {
                externalDomain: getCSCEndpoint(),
              }
            ),
          }
        : review.cscContactID,
    contactStartDate: contactStartDate,
    contactEndDate: contactEndDate,
  };

  const verticalDisplay = {
    label: intl.formatMessage({
      id: 'cs_perfportal_contact_review_label_readonly_vertical',
      defaultMessage: 'Vertical:',
    }),
    value: getLabelFromValue(review.vertical, getAllVerticals()),
  };

  const relatedMetricDisplay = {
    label: intl.formatMessage({
      id: 'cs_perfportal_coaching_detail_label_readonly_metric',
      defaultMessage: 'Metric:',
    }),
    value: getLabelFromValue(review.relatedMetric!, getAllMetrics()),
  };

  const securityDisplay = {
    label: intl.formatMessage({
      id: 'cs_perfportal_contact_review_label_readonly_security_question',
      defaultMessage: 'Did the associate follow security policies?:',
    }),
    value:
      getLabelFromValue(
        review.followedSecurityPolicies,
        getAllSecurityOptions(intl)
      ) ?? null,
  };

  const noteDisplay = {
    label: intl.formatMessage({
      id: 'cs_perfportal_contact_review_label_readonly_contact_notes',
      defaultMessage: 'Contact notes:',
    }),
    value: review.content ?? '',
  };

  return [
    contactDisplay,
    verticalDisplay,
    relatedMetricDisplay,
    securityDisplay,
    noteDisplay,
  ];
};
